// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"96453769","599":"4dc1d524"}[chunkId] + ".chunk.js";
};